export enum CarrierOnboardingStep {
  PersonalDetails,
  PhoneVerification,
  Optional,
  EmailVerification,
  BusinessDetails,
  LicenseVerification,
  LoadTypes,
  VehicleTypes,
  OperatingAreas,
}

export const CARRIER_ONBOARDING_STEP_PATHS: Record<
  CarrierOnboardingStep,
  string
> = {
  [CarrierOnboardingStep.PersonalDetails]: 'personal-details',
  [CarrierOnboardingStep.PhoneVerification]: 'phone-verification',
  [CarrierOnboardingStep.Optional]: 'optional',
  [CarrierOnboardingStep.EmailVerification]: 'email-verification',
  [CarrierOnboardingStep.BusinessDetails]: 'business-details',
  [CarrierOnboardingStep.LicenseVerification]: 'license-verification',
  [CarrierOnboardingStep.LoadTypes]: 'load-types',
  [CarrierOnboardingStep.VehicleTypes]: 'vehicle-types',
  [CarrierOnboardingStep.OperatingAreas]: 'operating-areas',
};

export const CARRIER_ONBOARDING_PATH_TO_STEP: Record<
  string,
  CarrierOnboardingStep
> = {
  'personal-details': CarrierOnboardingStep.PersonalDetails,
  'phone-verification': CarrierOnboardingStep.PhoneVerification,
  optional: CarrierOnboardingStep.Optional,
  'email-verification': CarrierOnboardingStep.EmailVerification,
  'business-details': CarrierOnboardingStep.BusinessDetails,
  'license-verification': CarrierOnboardingStep.LicenseVerification,
  'load-types': CarrierOnboardingStep.LoadTypes,
  'vehicle-types': CarrierOnboardingStep.VehicleTypes,
  'operating-areas': CarrierOnboardingStep.OperatingAreas,
};

/** First step (enum value) that shows the progress bar. */
export const CARRIER_ONBOARDING_FIRST_PROGRESS_STEP =
  CarrierOnboardingStep.EmailVerification;

/** Last step in the onboarding flow. */
export const CARRIER_ONBOARDING_LAST_STEP =
  CarrierOnboardingStep.OperatingAreas;

/** Query flag when opening `/new-carrier/...` steps from the complete-profile hub. */
export const CARRIER_ONBOARDING_COMPLETE_PROFILE_HUB_QUERY_PARAM =
  'completeProfileHub';

/** Encoded return URL propagated through complete-profile and onboarding flows. */
export const CARRIER_ONBOARDING_NEXT_QUERY_PARAM = 'next';

/** Shown after completing every complete-profile step when redirecting back to `next`. */
export const COMPLETE_PROFILE_SHOW_COMPLETED_MODAL_PARAM =
  'completeProfileShowCompletedModal';

/** Presence-only check (query value may be `"true"` or empty). */
export function hasCompleteProfileHubQuery(queryParams: {
  has(name: string): boolean;
}): boolean {
  return queryParams.has(CARRIER_ONBOARDING_COMPLETE_PROFILE_HUB_QUERY_PARAM);
}

export function getCarrierOnboardingReturnUrlFromQuery(queryParams: {
  get(name: string): string | null;
}): string | undefined {
  const encodedReturnUrl = queryParams.get(CARRIER_ONBOARDING_NEXT_QUERY_PARAM);
  if (!encodedReturnUrl) {
    return undefined;
  }

  try {
    const decodedReturnUrl = decodeURIComponent(encodedReturnUrl);
    return decodedReturnUrl.length > 0 ? decodedReturnUrl : undefined;
  } catch {
    return undefined;
  }
}
